import { render } from "./ic-edit.vue?vue&type=template&id=3e264301&ts=true"
import script from "./ic-edit.vue?vue&type=script&lang=ts"
export * from "./ic-edit.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__